export default __webpack_public_path__ + "dist/media/LinkedIn.4c251a37.svg";